import { Loadable, useApiGet } from 'common'
import { ControllerIssue } from 'controller'

type ControllerIssues = ControllerIssue[]

export function useControllerIssues(): Loadable<ControllerIssues> {
    return useApiGet<ControllerIssues>('controllers/issues')
}
